import { type InvoiceDetails, type StatementType } from '../domain/invoices';
import type { InvoiceDetailsDTO, StatementTypeDto } from '../dto/invoices';

export const invoiceDetailDtoToInvoiceDetail = (
  statementDetail: InvoiceDetailsDTO
): InvoiceDetails => ({
  contract: statementDetail.contrato,
  creditValue: statementDetail.valorCredito,
  debitValue: statementDetail.valorDebito,
  description: statementDetail.descricao,
  installment: statementDetail.parcela,
  interestPlan: statementDetail.planoJuros,
  lastFree: statementDetail.ultimaGratis,
  statementId: statementDetail.idExtrato,
  transaction: statementDetail.transacao,
  transactionType: statementDetail.tipoTransacao,
});

export const invoiceTypeDtoToInvoiceType = (
  statementDto: StatementTypeDto
): StatementType => ({
  statementId: statementDto.idExtrato,
  currentBalance: statementDto.saldoAtual,
  dueDate: statementDto.vencimento,
  hasBill: statementDto.isPossuiBoleto,
  statementNumber: statementDto.numeroExtrato,
  invoiceValue: statementDto.valorFatura,
  minValue: statementDto.valorMinimo,
  previousBalance: statementDto.saldoAnterior,
  situation: statementDto.situacao,
  status: statementDto.status,
  totalCredit: statementDto.totalCredito,
  closure: statementDto.fechamento,
});
